module.exports = __webpack_public_path__ + "img/ico-share.76e732b7.svg";